﻿import React, { useId, useCallback, useState, useRef, useEffect } from "react";
import styles from "./MainAccordion.module.css";
import { landStoryIds } from "../../interfaces";

interface Props {
    activeStoryId?: landStoryIds;
    changeStory: (storyId: landStoryIds) => void;
}

const MainAccordion: React.FC<Props> = ({ activeStoryId, changeStory }) => {
    const reactId   = useId();
    const triggerId = `acc-trigger-${reactId}`;
    const panelId   = `acc-panel-${reactId}`;

    const [isOpen, setIsOpen] = useState(false);
    const accordionRef = useRef<HTMLDivElement>(null);

    const toggle = useCallback(() => setIsOpen((v) => !v), []);
    const close  = useCallback(() => setIsOpen(false), []);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (accordionRef.current && !accordionRef.current.contains(event.target as Node)) close();
        };
        if (isOpen) document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isOpen, close]);

    return (
        <div className={styles.acc} ref={accordionRef}>
            <section className={styles.acc__item}>
                <button
                    className={styles.acc__trigger}
                    type="button"
                    aria-expanded={isOpen}
                    aria-controls={panelId}
                    id={triggerId}
                    onClick={toggle}
                    onKeyDown={(e) => {
                        if (e.key === "Escape") close();
                    }}
                >
                <span className={styles.acc__title}>Test Now</span>
                <span className={styles.acc__chev} aria-hidden="true">
                    <svg viewBox="0 0 24 24" className={styles.acc__chevIcon}>
                    <path
                        d="M8 10l4 4 4-4"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2.2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    </svg>
                </span>
                </button>

                <div className={styles.acc__panel} id={panelId} role="region" aria-labelledby={triggerId}>
                    <div className={styles.acc__panelInner}>
                        <div className={styles.acc__link + (activeStoryId === "aap" ? ` ${styles.linkActive}` : "")} onClick={() => changeStory("aap")}>
                            <span className={styles.acc__dot + (activeStoryId === "aap" ? ` ${styles.dotActive}` : "")} aria-hidden="true" />
                            <span className={styles.acc__linkText}>Autonomous Accounts Payable</span>
                        </div>

                        <div className={styles.acc__link + (activeStoryId === "acc" ? ` ${styles.linkActive}` : "")} onClick={() => changeStory("acc")}>
                            <span className={styles.acc__dot + (activeStoryId === "acc" ? ` ${styles.dotActive}` : "")} aria-hidden="true" />
                            <span className={styles.acc__linkText}>Autonomous Call Center</span>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default MainAccordion;
